import { useParams } from 'react-router-dom'
import { useSubscription } from '@apollo/client'
import { notification } from 'antd'
import { isEmpty } from 'lodash'

import { showErrorNotification } from '../../core/helpers'

import { PENDING_STATUS } from '../../common/constants'

import { UNBLOCK_BRAND_CURATION_TASK_SUBSCRIPTION } from '../graphql/subscriptions'

const useUnblockBrandCurationTaskSubscription = refetchBrandCurationTask => {
  const { id } = useParams()

  useSubscription(UNBLOCK_BRAND_CURATION_TASK_SUBSCRIPTION, {
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (isEmpty(data)) {
        return null
      }

      const { unblockBrandCurationTask } = data

      if (unblockBrandCurationTask?.awaitingStatus === PENDING_STATUS.FAILED) {
        return showErrorNotification({
          title: 'Retry error',
          description: `Failed to retry curation on ${unblockBrandCurationTask?.brandCurationTaskId}.
            ${unblockBrandCurationTask?.reason}`,
        })
      }

      if (
        id !== unblockBrandCurationTask?.brandCurationTaskId &&
        unblockBrandCurationTask?.awaitingStatus === PENDING_STATUS.SUCCESS
      ) {
        const notificationKey = `open${Date.now()}`

        return notification.success({
          key: notificationKey,
          message: 'Retry Finished',
          description: `Successfully retried curation on brand curation task`,
          placement: 'topLeft',
        })
      }

      refetchBrandCurationTask(id)

      return notification.success({
        message: 'Retry Finished',
        description: `Successfully retried curation`,
        placement: 'topLeft',
      })
    },
  })
}

export default useUnblockBrandCurationTaskSubscription
